import { createComponent } from '@carvana/merch-components';

export const LoadingTileContainer = createComponent('div', {
  className:
    'h-[142px] border border-border-weak rounded-md gap-xl p-xl flex flex-col'
});

export const TileContainer = createComponent('div', {
  className:
    'box-border flex flex-col gap-xl p-xl w-full h-full bg-background-default border border-border-weak rounded-md group-hover/tile:border-border-default group-hover/tile:bg-background-weak'
});

export const TileTopSectionContent = createComponent('div', {
  className: 'relative flex flex-1 flex-col gap-4'
});

export const TileTopSectionWrapper = createComponent('div', {
  className: 'flex flex-row'
});
